import * as Yup from 'yup';
import { ReviewerType } from '../../../enums';
import { MESSAGE_MAX_LENGTH } from './constants';

export const validationSchema = (minCommentLength: number) => Yup.object().shape({
  stars: Yup.string()
    .required('Ce champ est obligatoire.'),
  textareaField: Yup.string()
    .trim()
    .required('Ce champ est obligatoire.')
    .min(minCommentLength, `Veuillez fournir au moins ${minCommentLength} caractères.`)
    .max(MESSAGE_MAX_LENGTH, `Votre avis est trop long ! Nous limitons la longueur des avis à ${MESSAGE_MAX_LENGTH} caractères… essayez de le raccourcir un peu.`),
  drivingLessons: Yup.number().min(0),
  fullCost: Yup.number().min(0),
  theoryExams: Yup.number().min(0),
  drivingExams: Yup.number().min(0),
  lastName: Yup.string()
    .required('Ce champ est obligatoire.'),
  firstName: Yup.string()
    .required('Ce champ est obligatoire.'),
  email: Yup.string()
    .trim('Ce champ ne peut pas inclure d\'espace au début et à la fin')
    .strict(true)
    .email('Veuillez fournir une adresse électronique valide.')
    .required('Ce champ est obligatoire.'),
  isAgreed: Yup.bool()
    .oneOf([true], 'Veuillez accepter les Conditions générales de publication des avis.'),
  practicalExamDate: Yup.date().required('Ce champ est obligatoire.').typeError('Ce champ doit être une date (jj/mm/aaaa).'),
  allowMaifProposal: Yup.bool(),
  reviewerType: Yup.string()
    .oneOf(Object.values(ReviewerType), 'Veuillez accepter les Conditions générales de publication des avis.')
    .required('Ce champ est obligatoire.'),
});

export const formInitialValues = {
  stars: '',
  reception: '',
  information: '',
  teaching: '',
  availability: '',
  quality: '',
  textareaField: '',
  licenseType: '',
  drivingLessons: '',
  fullCost: '',
  theoryExams: '',
  drivingExams: '',
  lastName: '',
  firstName: '',
  email: '',
  isAgreed: false,
  selectedSchoolId: '',
  practicalExamDate: undefined,
  allowMaifProposal: true,
  reviewerType: ReviewerType.Student,
};
